/**
 * java 接口通过代理调用
 */
import request from 'superagent';
import Utils from './utils';
import router from '../config/routes'
import store from '../store/index'
import host from 'Host';
import { Message } from 'element-ui';

const root = host.domain + '/admin/agent';


// target 项目的唯一标识

function apiBase(method, action, params, success, failure, target) {
    if (params) {
        params.token = store.getters.token || '';
        //params.token = '2e3e1cd6580b734c93a195a0a753425c';
        params = {params,target: encodeURIComponent(target || 'public'),action,account_type:store.getters.accountType || '',token:store.getters.token || ''};
        params = Utils.filterNull(params);
        var url = root + '/jpost';
        var r = request(method, url);
        if (method === 'POST' || method === 'PUT') {
            if (Utils.toType(params) == 'object') {
                // params = JSON.stringify(params);
            }
            r = r.send(params)
        } else if (method == 'GET' || method === 'DELETE') {
            r = r.query(params)
        }
    }
    r.end(function (err, res) {
        if (err) {
            Message({
                message: 'api error',
                type: 'warning'
            });
            return;
        };
        if(res.body){
            if (res.body.flag && res.body.flag > 0 && res.body.result) {
                if (success) {
                    success(res.body);
                }
            } else if(res.body.flag == -90901){
                //未登录
                if (store.state.user.isLogout) return false;
                Message({
                    message: res.body.message,
                    type: 'warning'
                });
                store.dispatch('LogOut');
            } else if(res.body.flag == -997){
                //未权限
                Message({
                    message: res.body.message,
                    type: 'warning'
                });
                setTimeout(
                    function () {
                        router.push({path: '/dashboard'});
                    },1000)
            } else {
                if (failure) {
                    failure(res.body);
                } else {
                    //alert('error: ' + JSON.stringify(res.body));
                    Message({
                        message: res.body.message,
                        type: 'warning'
                    });
                }
            }
        }
    });
};


export default {
    get (action, params, success, failure, target) {
        return apiBase('GET', encodeURIComponent(action), params, success, failure, target)
    },
    post (action, params, success, failure, target) {
        return apiBase('POST', encodeURIComponent(action), params, success, failure, target)
    },
    put (action, params, success, failure, target) {
        return apiBase('PUT', encodeURIComponent(action), params, success, failure, target)
    },
    delete (action, params, success, failure, target) {
        return apiBase('DELETE', encodeURIComponent(action), params, success, failure, target)
    }
}



// WEBPACK FOOTER //
// ./vue/common/apiJava.js